// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--2gV_n","content":"Header-module--content--2DdbC","logo":"Header-module--logo--2Zf4H"};